module.exports = __webpack_public_path__ + "img/新版-定价_背景.ca1798bf.jpg";